// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stud-name {
  margin-top: 5px;
  margin-bottom: 10px;
}

.add-icon {
  font-size: larger;
  margin-top: 5px;
  margin-left: 5px;
}

.time-picker {
  --backdrop-opacity: 0.5 !important;
}

.disabled-label {
  color: gray;
}`, "",{"version":3,"sources":["webpack://./src/app/manage-presenza/manage-presenza.page.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,mBAAA;AACJ;;AACA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,kCAAA;AAGJ;;AAAA;EACI,WAAA;AAGJ","sourcesContent":[".stud-name {\n    margin-top: 5px;\n    margin-bottom: 10px;\n}\n.add-icon {\n    font-size: larger;\n    margin-top: 5px;\n    margin-left: 5px;\n}\n.time-picker {\n    --backdrop-opacity: 0.5 !important;\n}\n\n.disabled-label {\n    color: gray;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
